import { createClassName } from 'utils/createClassName';

export const createPreloaderClassName = createClassName('preloader');
